export default "__VITE_ASSET__79cf8a50__"